import * as angular from 'angular';

export interface StorageLocationResource extends ng.resource.IResourceClass<
    ng.resource.IResource<StorageLocationDto>
> {
    getAll: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageLocationDto>
    >;
    getFcfsOffersForLocation: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageFcfsOfferDto>
    >;
    get: ng.resource.IResourceMethod<ng.resource.IResource<StorageLocationDto>>;
    save: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageLocationDto>
    >;
}

function storageLocationResource(
    $resource: ng.resource.IResourceService,
    API_URL
): StorageLocationResource {
    return <StorageLocationResource>$resource(
        API_URL.STORAGE_LOCATION,
        {},
        {
            getAll: {
                method: 'GET',
                url: API_URL.STORAGE_LOCATION,
                isArray: true
            },
            get: {
                method: 'GET',
                url: API_URL.STORAGE_LOCATION + '/:id'
            },
            save: {
                method: 'POST',
                url: API_URL.STORAGE_LOCATION
            },
            getFcfsOffersForLocation: {
                method: 'GET',
                url: API_URL.STORAGE_LOCATION + '/:id/fcfs-offer',
                isArray: true
            }
        }
    );
}

angular
    .module('app')
    .factory('storageLocationResource', storageLocationResource);
